import { CircularProgress, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import Grid from '@mui/material/Grid'
import React from 'react'

const NotAuthenticated = () => {
    const { t } = useTranslation()
    return (
        <Grid container sx={{ flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start', padding: 4 }} style={{ height: '100vh' }} spacing={2}>
            <CircularProgress color="primary" />
            <Typography>{t('main.redirectLogin')}</Typography>
        </Grid>
    )
}

export default NotAuthenticated
